import type { ControlListItem } from "@/models/control.model";
import { TextField } from "@spz/ui/components/textfield";
import type { Table } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const ControlListSearchBar = ({
  table,
}: { table: Table<ControlListItem> }) => {
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const searchTerm = table.getState().globalFilter ?? "";

  return (
    <TextField
      placeholder={t("search_controls_placeholder")}
      leftIcon="search"
      value={searchTerm}
      onChange={handleChange}
      className="text-gray-700"
      data-testid="control-list-search-input"
    />
  );
};
